<div class="dealer-selector">
    <h4>DEALER SELECTOR</h4>
    <div class="item" *ngFor="let store of dealers" [class.selected]="store.id === dealer.id" (click)="onDealerClick(store)">
        <ion-icon name="checkmark-circle" *ngIf="store.id === dealer.id"></ion-icon>
        <h5>{{ store.name }}</h5>
        <p>{{ store.address }}, {{ store.city }}, {{ store.province }} {{ store.country }}</p>
        <div class="circle" [class.new]="store.alerts > 0">{{ store.alerts }}</div>
    </div>
</div>


